export const P = {
  ink: '#262626',
  muted: '#595959',
  subtle: '#8C8C8C',
  faint: '#BFBFBF',
  navy: 'var(--brand-primary)',
  navyInk: 'var(--brand-primary)',
  grad: 'var(--brand-grad)',
  gradHover: 'var(--brand-grad)',
  success: '#2E9D68',
  warning: '#C58C1F',
  danger: '#D0494E',
  info: '#3E77C2',
  purple: '#7A5CC5',
  cyan: '#1E9E9E',
  accent: '#D2711E',
  line: '#F0F0F0',
  border: '#D9D9D9',
  bgSubtle: '#FAFAFA',
  rowHover: '#F5F7FA',
  rowSel: '#E1E8F1',
  gray100: '#F5F5F5',
  gray200: '#E8E8E8',
  white: '#FFFFFF',
  action: '#D2711E',
  actionHover: '#B85F16'
};

export const tint = (c) => `color-mix(in oklch, ${c} 12%, white)`;
export const tintB = (c) => `color-mix(in oklch, ${c} 35%, white)`;
export const tintT = (c) => `color-mix(in oklch, ${c}, black 25%)`;

export const pillSt = (c, extra = {}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: 12,
  fontWeight: 600,
  padding: '3px 10px',
  borderRadius: 999,
  whiteSpace: 'nowrap',
  background: tint(c),
  border: `1px solid ${tintB(c)}`,
  color: tintT(c),
  ...extra
});

export const radius = { sm: 6, md: 8, lg: 12, xl: 16, pill: 999 };
export const shadow = { sm: '0 2px 8px rgba(0,0,0,.06)', md: '0 4px 16px rgba(0,0,0,.08)' };
export const fs = { xs: 12, sm: 13, base: 14, md: 16, lg: 20 };
export const fontSans = "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
const fontEyebrow = "'Montserrat', -apple-system, sans-serif";
export const fontMono = "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace";
export const ease = 'cubic-bezier(0.22, 1, 0.36, 1)';

export const PHONE = 600;
export const TABLET = 991;
export const onPhone = `@media (max-width: ${PHONE}px)`;
export const phoneControls = { controlHeight: 36, controlHeightSM: 28, controlHeightLG: 40 };
export const scrollRow = `
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const eyebrow = `
  font-family: ${fontEyebrow};
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${P.subtle};
  ${onPhone} {
    font-size: 12px;
  }
`;

export const eyebrowLabel = `
  ${eyebrow}
  font-size: 11px;
  letter-spacing: 0.14em;
  ${onPhone} {
    font-size: 12px;
  }
`;

export const card = `
  background: ${P.white};
  border: 1px solid ${P.line};
  border-radius: ${radius.lg}px;
  box-shadow: ${shadow.sm};
`;

export const TONES = {
  info: { fill: '#0958d9', bg: '#e6f4ff' },
  purple: { fill: '#531dab', bg: '#f9f0ff' },
  cyan: { fill: '#08979c', bg: '#e6fffb' },
  success: { fill: '#389e0d', bg: '#f6ffed' },
  warning: { fill: '#d46b08', bg: '#fff7e6' },
  danger: { fill: '#cf1322', bg: '#fff1f0' },
  default: { fill: '#8c8c8c', bg: '#fafafa' }
};

export const toneOf = (tone) => TONES[tone] || TONES.default;
